import { connect } from 'react-redux';
import ClientDashboard from './ClientDashboard';

import { setToggleDelete } from '../common/settings/actions';
import { getClientsList, setClientId } from '../AddClient/actions';


const mapStateToProps = state => ({
    authToken: state.auth.authToken,
    clientsList: state.addClientUI.clientsList,
    clientUpdateStatus: state.addClientUI.clientUpdateStatus,
    toggleDelete: state.settings.toggleDelete,
});

const mapDispatchToProps = dispatch => ({
    setToggleDelete: toggleDelete => dispatch(setToggleDelete(toggleDelete)),
    getClientsList: authToken => dispatch(getClientsList(authToken)),
    setClientId: clientId => dispatch(setClientId(clientId)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ClientDashboard);



// WEBPACK FOOTER //
// ./src/containers/ClientsDashboard/index.js